import request from '@/utils/request'

let CarouselApi = {
  /*轮播图列表*/
  CarouselList(data) {
    return request._post('/shop/plus.carousel.carousel/index', data);
  },
  /*获取轮播图分类*/
  getCategory(data) {
    return request._post('/shop/plus.carousel.carouselcategory/index', data);
  },
  /*添加轮播图*/
  toAddCarousel(data) {
    return request._get('/shop/plus.carousel.carousel/add', data);
  },
  /*添加轮播图*/
  addCarousel(data) {
    return request._post('/shop/plus.carousel.carousel/add', data);
  },
  /*轮播图详情*/
  toEditCarousel(data) {
    return request._get('/shop/plus.carousel.carousel/edit', data);
  },
  /*编辑轮播图*/
  editCarousel(data) {
    return request._post('/shop/plus.carousel.carousel/edit', data);
  },
  /*删除轮播图*/
  deleteCarousel(data) {
    return request._post('/shop/plus.carousel.carousel/delete', data);
  },
  /*添加分类*/
  addCategory(data) {
    return request._post('/shop/plus.carousel.carouselcategory/add', data);
  },
  /*编辑分类*/
  editCategory(data) {
    return request._post('/shop/plus.carousel.carouselcategory/edit', data);
  },
  /*删除分类*/
  deleteCategory(data) {
    return request._post('/shop/plus.carousel.carouselcategory/delete', data);
  },


}
export default CarouselApi;



// WEBPACK FOOTER //
// ./src/api/carousel.js